<!--
    描述：详细分析 --- 表格模块
    时间：2020-07-30
    Created by ws
-->
<template>
    <div class="w-table-layout bd-table">
        <div class="w-table-content" ref="tableContent">
            <el-table
                class="footerTable"
                ref="xTable"
                :height="tableH"
                :data="tableData"
                highlight-current-row
                v-loading="loading"
                show-summary
                border
                :summary-method="getSummaries"
                :cell-style="cellStyle"
                :header-cell-style="headerCellStyle"
                :cell-class-name="cellClass"
                @header-click="headerClick"
                stripe
            >
                <el-table-column type="index" label="序号" align="center" width="50">
                </el-table-column>
                <el-table-column
                    prop="sname"
                    label="单位工程名称"
                    align="center"
                    sortable
                    min-width="180"
                >
                </el-table-column>
                <el-table-column
                    prop="code"
                    label="清单编码"
                    align="center"
                    sortable
                    show-overflow-tooltip
                    width="120"
                >
                </el-table-column>
                <el-table-column
                    header-align="center"
                    v-if="compareArr1.length > 0"
                    prop="type1"
                    width="710"
                >
                    <template slot="header" slot-scope="scope">
                        <el-select v-model="priceType1" size="small">
                            <el-option
                                v-for="(item, index) in priceTypeList"
                                :key="'价格类别' + index"
                                :label="item.name"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </template>
                    <el-table-column
                        :prop="`str1.projectName`"
                        label="清单名称"
                        width="150"
                        resizable
                        sortable
                        header-align="center"
                        align="left"
                    >
                        <template slot-scope="scope">
                            <el-tooltip
                                placement="right"
                                :disabled="compareArr1.includes('projectFeatures')"
                            >
                                <div slot="content">
                                    {{ scope.row.str1.projectFeatures }}
                                </div>
                                <div>{{ scope.row.str1.projectName }}</div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :prop="`str1.projectFeatures`"
                        label="清单特征"
                        v-if="compareArr1.includes('projectFeatures')"
                        width="150"
                        resizable
                        sortable
                        header-align="center"
                        align="left"
                        show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                        :prop="`str1.unit`"
                        v-if="compareArr1.includes('unit')"
                        label="计量单位"
                        width="110"
                        sortable
                        header-align="center"
                        align="center"
                    ></el-table-column>
                    <el-table-column
                        :prop="`str1.quantity`"
                        v-if="compareArr1.includes('quantity')"
                        label="工程量"
                        sortable
                        width="110"
                        header-align="center"
                        align="right"
                    >
                        <template slot-scope="scope">{{
                            scope.row.str1.quantity
                                ? scope.row.str1.quantity.toFixed(2)
                                : "0.00"
                        }}</template>
                    </el-table-column>
                    <el-table-column
                        :prop="`str1.rateCost`"
                        v-if="compareArr1.includes('rateCost')"
                        label="单价"
                        sortable
                        width="100"
                        header-align="center"
                        align="right"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">{{
                            scope.row.str1.rateCost
                                ? scope.row.str1.rateCost.toFixed(2)
                                : "0.00"
                        }}</template>
                    </el-table-column>
                    <el-table-column
                        :prop="`str1.addup`"
                        v-if="compareArr1.includes('addup')"
                        label="合价"
                        sortable
                        :sort-by="sortAddup"
                        width="120"
                        header-align="center"
                        align="right"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">{{
                            scope.row.str1.addup
                                ? scope.row.str1.addup.toFixed(2)
                                : "0.00"
                        }}</template>
                    </el-table-column>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="type2"
                    v-if="compareArr2.length > 0"
                    width="710"
                >
                    <template slot="header" slot-scope="scope">
                        <el-select v-model="priceType2" size="small">
                            <el-option
                                v-for="(item, index) in priceTypeList"
                                :key="'价格类别' + index"
                                :label="item.name"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </template>
                    <el-table-column
                        :prop="`str2.projectName`"
                        label="清单名称"
                        width="150"
                        sortable
                        resizable
                        header-align="center"
                        align="left"
                    >
                        <template slot-scope="scope">
                            <el-tooltip
                                placement="right"
                                :disabled="compareArr2.includes('projectFeatures')"
                            >
                                <div slot="content">
                                    {{ scope.row.str2.projectFeatures }}
                                </div>
                                <div>{{ scope.row.str2.projectName }}</div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :prop="`str2.projectFeatures`"
                        label="清单特征"
                        v-if="compareArr2.includes('projectFeatures')"
                        width="150"
                        resizable
                        sortable
                        header-align="center"
                        align="left"
                        show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                        :prop="`str2.unit`"
                        v-if="compareArr2.includes('unit')"
                        label="计量单位"
                        width="110"
                        sortable
                        header-align="center"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        :prop="`str2.quantity`"
                        v-if="compareArr2.includes('quantity')"
                        label="工程量"
                        sortable
                        width="110"
                        header-align="center"
                        align="right"
                    >
                        <template slot-scope="scope">{{
                            scope.row.str2.quantity
                                ? scope.row.str2.quantity.toFixed(2)
                                : "0.00"
                        }}</template>
                    </el-table-column>
                    <el-table-column
                        :prop="`str2.rateCost`"
                        v-if="compareArr2.includes('rateCost')"
                        label="单价"
                        width="100"
                        sortable
                        header-align="center"
                        align="right"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">{{
                            scope.row.str2.rateCost
                                ? scope.row.str2.rateCost.toFixed(2)
                                : "0.00"
                        }}</template>
                    </el-table-column>
                    <el-table-column
                        :prop="`str2.addup`"
                        v-if="compareArr2.includes('addup')"
                        label="合价"
                        width="120"
                        sortable
                        header-align="center"
                        align="right"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">{{
                            scope.row.str2.addup
                                ? scope.row.str2.addup.toFixed(2)
                                : "0.00"
                        }}</template>
                    </el-table-column>
                </el-table-column>
                <el-table-column
                    label="异常原因"
                    width="250"
                    prop="reasons"
                    align="left"
                    header-align="center"
                ></el-table-column>
                <el-table-column
                    prop="amount"
                    v-if="amountArr.length > 0"
                    label="增减量"
                    width="330"
                    align="center"
                >
                    <el-table-column
                        label="工程量"
                        prop="decrement.decrementQuality"
                        v-if="amountArr.includes('quantity')"
                        header-align="center"
                        sortable
                        :sort-by="amountSort1"
                        align="right"
                        width="100"
                    >
                    </el-table-column>
                    <el-table-column
                        label="单价"
                        prop="decrement.decrementRateCost"
                        v-if="amountArr.includes('rateCost')"
                        sortable
                        :sort-by="amountSort2"
                        header-align="center"
                        align="right"
                        width="100"
                    >
                    </el-table-column>
                    <el-table-column
                        label="合价"
                        prop="decrement.decrementAddup"
                        v-if="amountArr.includes('addup')"
                        sortable
                        :sort-by="amountSort3"
                        header-align="center"
                        align="right"
                        show-overflow-tooltip
                        width="120"
                    >
                    </el-table-column>
                </el-table-column>
                <el-table-column
                    label="增减幅度"
                    prop="amountRate"
                    v-if="rateArr.length > 0"
                    align="center"
                    width="330"
                >
                    <el-table-column
                        label="工程量"
                        prop="range.rangeQuality"
                        v-if="amountArr.includes('quantity')"
                        sortable
                        :sort-by="rateSort1"
                        header-align="center"
                        align="right"
                        width="100"
                    >
                    </el-table-column>
                    <el-table-column
                        label="单价"
                        prop="range.rangePrice"
                        v-if="amountArr.includes('rateCost')"
                        sortable
                        :sort-by="rateSort2"
                        header-align="center"
                        align="right"
                        width="100"
                    >
                    </el-table-column>
                    <el-table-column
                        label="合价"
                        prop="range.rangeSumPrice"
                        v-if="amountArr.includes('addup')"
                        sortable
                        :sort-by="rateSort3"
                        header-align="center"
                        align="right"
                        show-overflow-tooltip
                        width="120"
                    >
                    </el-table-column>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { selectAnalysis, selectConditionArray, getLaborData } from "@/api/modules/analysisDetail";
export default {
    name: "project-list",
    props: {
        searchForm: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {
            tableH: 100, // 表格高度
            pageSize: 10, // 当前显示条数
            fixedData: [], // 固定的原始数据
            tableData: [],
            priceTypeList: [],
            priceType1: "1007002", // 默认控制价
            priceType2: "1007003", // 默认中标价
            loading: false,
            curColumn: "", // 当前点击的列 property
            // 对比列 列过滤
            compareArr1: ["unit", "quantity", "rateCost", "addup"],
            compareArr2: ["unit", "quantity", "rateCost", "addup"],
            // 增减量列过滤
            amountArr: ["quantity", "rateCost", "addup"],
            // 增减幅度列过滤
            rateArr: ["quantity", "rateCost", "addup"],
            // 列筛选
            filterObj: {
                // 工程量
                quantity: {
                    amount: 100,
                    rate: 5,
                },
                // 单价
                rateCost: {
                    amount: 100,
                    rate: 3,
                },
                // 合价
                addup: {
                    amount: 10000,
                    rate: 6,
                },
            },
        };
    },
    created() {
        // 初始获得表格数据
        this.getPeriods();
        // this.getTableData()

        this.$nextTick(() => {
            this.tableH = this.$refs.tableContent.offsetHeight;
        });
    },
    methods: {
        // 初始获得数据
        getTableData(params) {
            this.tableData = [];

            if (params.treeIds.length > 0) {
                this.loading = true;

				getLaborData(params)
					.then(res => {
						this.loading = false;

						this.fixedData = res.data.list;
                    	this.tableData = res.data.list;
					})
					.catch(err => {
						this.loading = false;
					})
                // selectAnalysis(params).then((res) => {
                //     this.loading = false;
                //     // console.log(res)
                //     this.fixedData = res.data.list;
                //     this.tableData = res.data.list;
                // });
            }
            // if (params.treeIds.length > 0) {
            //     this.loading = true;
            //     selectAnalysis(params).then((res) => {
            //         this.loading = false;
            //         // console.log(res)
            //         this.fixedData = res.data.list;
            //         this.tableData = res.data.list;
            //     });
            // }
        },

        // 初始获取期数
        getPeriods() {
            this.priceTypeList = [];
            selectConditionArray({
                id: this.curProjectId,
                // tag: 0, // 当前还是累计
            })
                .then((res) => {
                    this.priceTypeList = res.data;
                })
                .catch((err) => {});
        },

        // 计算增减量
        getAmount(type, row) {
            let parent = parseFloat(row[this.priceType2][type]) || 0;
            let child = parseFloat(row[this.priceType1][type]) || 0;
            let value;
            switch (type) {
                case "quantity":
                    value = parent.sub(child).toFixed(3);
                    break;
                case "rateCost":
                    value = parent.sub(child).toFixed(2);
                    break;
                case "addup":
                    value = parent.sub(child).toFixed(2);
                    break;
            }
            return value;
        },

        // 计算增减幅度
        getRate(type, row) {
            let parent = parseFloat(row[this.priceType2][type]) || "";
            let child = parseFloat(row[this.priceType1][type]) || "";
            // 如果有没数据的
            if (parent === "" || child === "") {
                return "---";
            }
            // 有数据
            return (parent / child).sub(1).mul(100).toFixed(2) + "%";
        },

        // 重新调整表格高度
        resizeTable() {
            setTimeout(() => {
                this.$refs.xTable.doLayout();
                this.tableH = this.$refs.tableContent.offsetHeight;
            }, 1000);
        },

        // 列类名
        cellClass({ row, column, rowIndex, columnIndex }) {
            // 类型1 的
            if (this.curColumn === "type1") {
                if (
                    column.property === this.priceType1 + ".projectFeatures" ||
                    column.property === this.priceType1 + ".unit" ||
                    column.property === this.priceType1 + ".quantity" ||
                    column.property === this.priceType1 + ".rateCost" ||
                    column.property === this.priceType1 + ".addup"
                ) {
                    return "active-cell";
                } else {
                    return "";
                }
            }

            // 类型2 的
			let arr2 = [
				'str2.projectName',
				'str2.projectFeatures',
				'str2.unit',
				'str2.quantity',
				'str2.rateCost',
				'str2.addup',
			]
			if (arr2.includes(column.property) && row.reasons !== '') {
				return 'error-cell'
			}
            if (this.curColumn === "type2") {
                if (
                    column.property === this.priceType2 + ".projectFeatures" ||
                    column.property === this.priceType2 + ".unit" ||
                    column.property === this.priceType2 + ".quantity" ||
                    column.property === this.priceType2 + ".rateCost" ||
                    column.property === this.priceType2 + ".addup"
                ) {
                    return "active-cell";
                } else {
                    return "";
                }
            }

            // 增减量的
            if (this.curColumn === "amount") {
                if (
                    column.property === "decrement.decrementQuality" ||
                    column.property === "decrement.decrementRateCost" ||
                    column.property === "decrement.decrementAddup"
                ) {
                    return "active-cell";
                } else {
                    return "";
                }
            }

            // 增减幅度的
            if (this.curColumn === "amountRate") {
                if (
                    column.property === "range.rangeQuality" ||
                    column.property === "range.rangePrice" ||
                    column.property === "range.rangeSumPrice"
                ) {
                    return "active-cell";
                } else {
                    return "";
                }
            }

            // 剩下单独的
            if (this.curColumn === column.property) {
                return "active-cell";
            } else {
                return "";
            }
        },

        // 列样式
        cellStyle({ row, column }) {
            let value;
            switch (column.property) {
                case "amount.quantity":
                    value = parseFloat(this.getAmount("quantity", row));
                    break;
                case "amount.rateCost":
                    value = parseFloat(this.getAmount("rateCost", row));
                    break;
                case "amount.addup":
                    value = parseFloat(this.getAmount("addup", row));
                    break;
                case "amountRate.quantity":
                    value = parseFloat(this.getRate("quantity", row));
                    break;
                case "amountRate.rateCost":
                    value = parseFloat(this.getRate("rateCost", row));
                    break;
                case "amountRate.addup":
                    value = parseFloat(this.getRate("addup", row));
                    break;
                default:
                    value = "";
            }

            if (value === "") {
                // return { color: '#666' }
            } else {
                if (value < 0) {
                    return { color: "green" };
                } else if (value > 0) {
                    return { color: "red" };
                } else {
                    return { color: "blue" };
                }
            }
        },

        // 表头列样式
        headerCellStyle({ row, column, rowIndex, columnIndex }) {
            if (column.children && !column.label) {
                if (column.property === "type2") {
                    return { backgroundColor: "#039be5 !important" };
                }
            }

            if (column.level === 2) {
                // if (
                // 	column.property === 'str1.projectFeatures' ||
                // 	column.property === 'str1.projectFeatures' ||
                // 	column.property === 'str1.unit' ||
                // 	column.property === 'str1.quantity' ||
                // 	column.property === 'str1.rateCost' ||
                // 	column.property === 'str1.addup'
                // ) {
                // 	return { backgroundColor: '#9eefd1' }
                // }

                if (
                    column.property === "str2.projectName" ||
                    column.property === "str2.projectFeatures" ||
                    column.property === "str2.unit" ||
                    column.property === "str2.quantity" ||
                    column.property === "str2.rateCost" ||
                    column.property === "str2.addup"
                ) {
                    return { backgroundColor: "#039be5 !important" };
                }
            }
        },

        // 获取当前选择的对比列 名称
        getColumnName() {
            let params = {
                column1: "",
                column2: "",
            };

            if (this.priceTypeList.length > 0) {
                let _item1 = this.priceTypeList.find((x) => x.value === this.priceType1);
                let _item2 = this.priceTypeList.find((x) => x.value === this.priceType2);
                params.column1 = _item1 ? _item1.name : "";
                params.column2 = _item2 ? _item2.name : "";
            }

            return params;
        },

        // 显示范围数据过滤
        doRangeFilter(type, params) {
            if (params.amount === "" && params.rate === "") {
                return;
            }
            let arr = JSON.parse(JSON.stringify(this.fixedData));
            let _amountArr = [];
            let _rateArr = [];
            arr.forEach((x) => {
                let value2 = parseFloat(x[this.priceType2][type]) || 0;
                let value1 = parseFloat(x[this.priceType1][type]) || 0;

                if (value2 - value1 > params.amount) {
                    _amountArr.push(x);
                }

                if (parseFloat((value2 / value1).sub(1).mul(100)) > params.rate) {
                    _rateArr.push(x);
                }
            });

            // 如果是交集
            let newArr = [];
            if (params.isSupport) {
                newArr = _amountArr.filter((item) =>
                    _rateArr.some((x) => x.code === item.code)
                );
            } else {
                // 如果是并集
                newArr = _amountArr.concat(_rateArr);
                // 去重
                newArr = newArr.filter(
                    (item, index) =>
                        newArr.findIndex((y) => y.code === item.code) === index
                );
            }
            this.tableData = newArr;
        },

        // 单一合价排序
        sortAddup(row, index) {
            if (row) {
                return parseFloat(row.str1.addup);
            }
        },

        // 增减量的自定义排序 --- 工程量
        amountSort1(row, index) {
            if (row) {
                return parseFloat(row.decrement.decrementQuality);
            }
        },

        amountSort2(row, index) {
            if (row) {
                return parseFloat(row.decrement.decrementRateCost);
            }
        },

        amountSort3(row, index) {
            if (row) {
                return parseFloat(row.decrement.decrementAddup);
            }
        },

        // 增减幅度自定义排序 --- 工程量
        rateSort1(row, index) {
            if (row) {
                return parseFloat(row.range.rangeQuality);
            }
        },

        // --- 单价
        rateSort2(row, index) {
            if (row) {
                return parseFloat(row.range.rangePrice);
            }
        },

        // --- 合价
        rateSort3(row, index) {
            if (row) {
                return parseFloat(row.range.rangeSumPrice);
            }
        },

        // 增减幅度自定义筛选数据 --- 工程量
        filterRate1(value, row, column) {
            if (row) {
                let value2 = parseFloat(row[this.priceType2].quantity) || 0;
                let value1 = parseFloat(row[this.priceType1].quantity) || 0;
                return parseFloat((value2 / value1).sub(1).mul(100)) > value;
            }
        },

        // 增减幅度自定义筛选数据 --- 单价
        filterRate2(value, row, column) {
            if (row) {
                let value2 = parseFloat(row[this.priceType2].rateCost) || 0;
                let value1 = parseFloat(row[this.priceType1].rateCost) || 0;

                if (value === "小于等于") {
                    return (
                        parseFloat((value2 / value1).sub(1).mul(100)) <=
                        parseFloat(this.filterObj.rateCost.rate)
                    );
                }

                return parseFloat((value2 / value1).sub(1).mul(100)) > parseFloat(value);
            }
        },

        filterRate3(value, row, column) {
            if (row) {
                let value2 = parseFloat(row[this.priceType2].addup) || 0;
                let value1 = parseFloat(row[this.priceType1].addup) || 0;

                return parseFloat((value2 / value1).sub(1).mul(100)) > parseFloat(value);
            }
        },

        // 清除所有列过滤
        clearFilter() {
            this.$refs.xTable.clearFilter();
        },

        // 表尾合计行
        getSummaries(param) {
            this.$nextTick(() => {
                this.$refs.xTable.doLayout();
            });
            const { columns, data } = param;
            const sums = [];
            let sum2 = 0,
                sum1 = 0;

            columns.forEach((column, index) => {
                sums[index] = "N/A";

                if (index === 0) {
                    sums[index] = "合计";
                    return;
                }

                // 第一个 合价
                if (column.property === "str1.addup") {
                    let values = data.map((x) => parseFloat(x.str1.addup));

                    if (!values.every((value) => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        sum1 = sums[index];
                        sums[index] = sums[index].toFixed(2) + " 元";
                    }
                }

                // 第二个合价
                if (column.property === "str2.addup") {
                    let values = data.map((x) => parseFloat(x.str2.addup));

                    if (!values.every((value) => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        sum2 = sums[index];
                        sums[index] = sums[index].toFixed(2) + " 元";
                    }
                }

                // 增减量 合价
                if (column.property === "decrement.decrementAddup") {
                    sums[index] = sum2.sub(sum1).toFixed(2) + " 元";
                }

                // 增减幅度 合价
                if (column.property === "range.rangeSumPrice") {
                    sums[index] =
                        sum1 !== 0 ? (sum2 / sum1 - 1).mul(100).toFixed(2) + " %" : "N/A";
                }
            });
            return sums;
        },

        // 表头点击事件
        headerClick(column, event) {
            this.curColumn = column.property;
        },

		// 获取选中的 phase的Type
		getPhaseObj() {
			let _item1 = this.priceTypeList.find((x) => x.value === this.priceType1)
			let _item2 = this.priceTypeList.find((x) => x.value === this.priceType2)

			let _name1 = _item1 ? _item1.name : ''
			let _name2 = _item2 ? _item2.name : ''

			return {
				type1: _item1 ? _item1.type : '',
				type2: _item2 ? _item2.type : '',
				nameStr: _name1 + ',' + _name2
			}
		},

        // 获取 当前选中的 name
        getPhaseName() {
            let name1 =
                this.priceTypeList.find((x) => x.value === this.priceType1).name || "";
            let name2 =
                this.priceTypeList.find((x) => x.value === this.priceType2).name || "";
            return name1 + "," + name2;
        },
    },
    computed: {
        ...mapState("app", {
            clientSize: (state) => state.clientSize,
        }),
        curProjectId() {
            return this.$route.query.projectId;
        },
    },
    watch: {
        clientSize(obj) {
            this.tableH = this.$refs.tableContent.offsetHeight;
        },
        // 监听两个下拉选的变化
        priceType1(val) {
            let params = Object.assign({}, this.searchForm);
            params.phases = val + "," + this.priceType2;
			params.phase1 = this.priceType1
            params.phase2 = this.priceType2
            params.type1 = this.getPhaseObj().type1
            params.type2 = this.getPhaseObj().type2

            this.getTableData(params);
        },
        priceType2(val) {
            let params = Object.assign({}, this.searchForm);
            params.phases = this.priceType1 + "," + val;
            params.phase1 = this.priceType1
            params.phase2 = this.priceType2
            params.type1 = this.getPhaseObj().type1
            params.type2 = this.getPhaseObj().type2

            this.getTableData(params);
        },
    },
};
</script>

<style lang="less" scoped>
.footerTable {
    box-sizing: unset !important;
}
</style>
